import { FlexGrid, Header, Panel, Text } from '@gasbuddy/react-components';
import { usePrevious } from '@gasbuddy/react-hooks';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { noop } from '../../../lib/utils';
import styles from './TopSpottersList.module.css';

const cx = classnames.bind(styles);

export default function TopSpottersList({ fetchTopSpotters, stationId, topSpotters, isFetching }) {
  const wasFetching = usePrevious(isFetching);

  useEffect(() => {
    if (stationId && !isFetching && !wasFetching && !topSpotters.length) {
      fetchTopSpotters(stationId);
    }
  }, [fetchTopSpotters, isFetching, stationId, topSpotters.length, wasFetching]);

  if (topSpotters.length === 0) {
    return null;
  }

  return (
    <React.Fragment>
      <Header as="h3" className={cx('spottersHeader')}>
        Top Spotters
      </Header>
      <Panel className={cx('spotterItemsContainer')} color="white" padded={false} bordered rounded>
        {topSpotters.map((spotter, idx) => (
          <FlexGrid className={cx('gridRowAdditions')} container key={spotter.name}>
            <FlexGrid.Column mobile={2}>
              <div className={cx('regularNumber', { champNumber: !!spotter.champ })}>
                {idx + 1}
              </div>
            </FlexGrid.Column>
            <FlexGrid.Column mobile={2}>
              <div
                className={cx('avatarIcon')}
                style={{
                  backgroundImage: `url(${spotter.avatarUrl})`,
                }}
                title="Top Spotter Avatar"
              />
            </FlexGrid.Column>
            <FlexGrid.Column mobile={6}>
              <div className={cx('dontCrushMe')}>
                <a href={`https://www.gasbuddy.com/member/${spotter.name.toLowerCase()}`} className={cx('spotterName')}>
                  {spotter.name}
                </a>
              </div>
            </FlexGrid.Column>
            <FlexGrid.Column mobile={2}>
              <Text right>
                {spotter.streak}
              </Text>
            </FlexGrid.Column>
          </FlexGrid>
        ))}
      </Panel>
    </React.Fragment>
  );
}

TopSpottersList.propTypes = {
  isFetching: PropTypes.bool,
  stationId: PropTypes.string.isRequired,
  topSpotters: PropTypes.arrayOf(PropTypes.shape({
    avatarUrl: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    streak: PropTypes.number.isRequired,
    champ: PropTypes.shape({
      champStreak: PropTypes.number.isRequired,
    }),
  })),
  fetchTopSpotters: PropTypes.func,
};

TopSpottersList.defaultProps = {
  topSpotters: [],
  isFetching: false,
  fetchTopSpotters: noop,
};
